import { ApiError } from './api-error' // eslint-disable-line @typescript-eslint/no-restricted-imports

export type AuthErrorReason =
  | 'USER_DISABLED'
  | 'INVALID_CREDENTIALS'
  | 'USER_DELETED'
  | 'ONBOARDING_INCOMPLETE'
export class AuthenticationError extends ApiError {
  reason?: AuthErrorReason

  constructor(reason?: AuthErrorReason) {
    super('Authentication failed', 401, 'AUTH_FAILED')
    this.name = 'AuthenticationError'
    this.reason = reason
  }
}
